import { render, staticRenderFns } from "./PerformanceStatistics.vue?vue&type=template&id=4312debc&scoped=true&"
import script from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
export * from "./PerformanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceStatistics.vue?vue&type=style&index=0&id=4312debc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312debc",
  null
  
)

export default component.exports